import axios from "axios";

export default {
  getGrowersDataOfDistrictByDistrictName(selectedDistrictName) {
    return axios.get(`/district/${selectedDistrictName}`);
  }
};
